export default "__VITE_ASSET__jD59V4$F__"